module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm._readonly) ? _c('p', {
    staticClass: "form-control-static"
  }, [_vm._v("\n  " + _vm._s(_vm.get(_vm.find(_vm._options, {
    value: _vm.value
  }), 'label', '')) + "\n")]) : (typeof _vm.spec.items === 'function') ? _c('el-select', {
    staticClass: "select-primary",
    style: (_vm.selectStyle),
    attrs: {
      "name": _vm._name,
      "filterable": !!_vm.spec.search,
      "placeholder": _vm.spec.placeholder,
      "readonly": _vm._readonly,
      "multiple": !!_vm.spec.multi,
      "remote": true,
      "remote-method": _vm.reload,
      "loading": _vm.loading,
      "value-key": _vm.spec.valueKey
    },
    on: {
      "input": _vm.onchange
    },
    model: {
      value: (_vm.value),
      callback: function($$v) {
        _vm.value = $$v
      },
      expression: "value"
    }
  }, _vm._l((_vm._options), function(option) {
    return _c('el-option', {
      staticClass: "select-primary",
      attrs: {
        "value": option.value,
        "label": option.label
      }
    })
  })) : _c('el-select', {
    staticClass: "select-primary",
    style: (_vm.selectStyle),
    attrs: {
      "name": _vm._name,
      "filterable": !!_vm.spec.search,
      "placeholder": _vm.spec.placeholder,
      "readonly": _vm._readonly,
      "multiple": !!_vm.spec.multi,
      "value-key": _vm.spec.valueKey
    },
    on: {
      "input": _vm.onchange
    },
    model: {
      value: (_vm.value),
      callback: function($$v) {
        _vm.value = $$v
      },
      expression: "value"
    }
  }, _vm._l((_vm._options), function(option) {
    return _c('el-option', {
      staticClass: "select-primary",
      attrs: {
        "value": option.value,
        "label": option.label
      }
    })
  }))
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-09f2aa0d!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Dashboard/Views/Forms/Fields/f-select.vue
// module id = 502
// module chunks = 55